module.exports = __webpack_public_path__ + "src/images/products/sneakerhead/56_Season 6 Classic Hoody.png";